/**
 * Media query for the cockpit sidebar rail (PMA-COCK-106, EPIC-111 UIJ-R1-1).
 * Landscape tablets up to 1180px keep the original rule; large-iPad
 * viewports (1024x1366 portrait, 1366x1024 landscape) also get the rail.
 * 1280x720 and 1440x900 desktops stay stacked (min-height 800 / max-width 1400).
 */
export const RAIL_LAYOUT_QUERY =
  "(max-width: 1180px) and (orientation: landscape), (min-width: 1024px) and (max-width: 1400px) and (min-height: 800px)";
